export default __webpack_public_path__ + "static/media/HelveticaNeueLTW1G-Md.672928f0.ttf";